import { render, staticRenderFns } from "./ResponsiveTableCell.vue?vue&type=template&id=2e0924c0&scoped=true"
import script from "./ResponsiveTableCell.vue?vue&type=script&lang=js"
export * from "./ResponsiveTableCell.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveTableCell.vue?vue&type=style&index=0&id=2e0924c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0924c0",
  null
  
)

export default component.exports